module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "tiktok_white.d3715517.svg";